import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { SeachSection } from "../../components/SpearParts/Layouts/SeachSection";
import Advancedfilter from "../AdvancedFilter/Advancedfilter";
import Axios from "../../axios/axios";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { toTitleCase } from "../../components/utils/StringUtil";
import NoData from "../../components/NoData/Index";
import "./product.css";
import Middle from "../../components/SpearParts/Layouts/Middle";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export default function ProductList() {
  const location = useLocation();
  const {
    parts = [],
    spareBrand = [],
    spareCategory = [],
    spareModels = [],
    region = [],
    years = [],
    subCategories = [],
    filters: initialFilters = {},
  } = location.state || {};

  const [filters, setFilters] = useState(initialFilters);
  const [filteredParts, setFilteredParts] = useState(parts);
  const [advResults, setAdvResults] = useState([]);
  const [originalSearchResults, setOriginalSearchResults] = useState(parts); // NEW
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [totalPages, setTotalPages] = useState(1);

  const getBrandName = (brandId) => {
    return (
      spareBrand.find((b) => b._id === (brandId?._id || brandId))?.name ||
      brandId?.name ||
      "Unknown Brand"
    );
  };

  const getModelName = (modelId) => {
    return (
      spareModels.find((m) => m._id === (modelId?._id || modelId))?.name ||
      modelId?.name ||
      "Unknown Model"
    );
  };

  const getCategoryName = (categoryId) => {
    return categoryId?.name || "Unknown Category";
  };

  const getRegionName = (regionId) => {
    return (
      region.find((r) => r._id === (regionId?._id || regionId))?.name ||
      regionId?.name ||
      "Unknown Region"
    );
  };

  const PartCard = ({ product }) => (
    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
      <Link
        to={`/singleproduct/${product._id}`}
        state={{ parts, spareCategory, spareBrand, spareModels, region }}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div
          className="prod-div p-2 d-flex flex-column align-items-center"
          style={{
            border: "1px solid #ddd",
            borderRadius: "8px",
            height: "100%",
          }}
        >
          {product?.images?.length > 0 && (
            <img
              src={product.images[0].url}
              alt={product.name}
              style={{
                width: "100%",
                height: "180px",
                objectFit: "contain",
                marginBottom: "60px",
              }}
            />
          )}
          <h6 className="mb-2 text-center">{toTitleCase(product.name)}</h6>
        </div>
      </Link>
    </div>
  );
  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryId = searchParams.get("categoryId");
    const subcategoryId = searchParams.get("subcategoryId");

    if (!categoryId && !subcategoryId) return;

    const fetchParts = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const categoryId = searchParams.get("categoryId");
        const subcategoryId = searchParams.get("subcategoryId");

        const res = await Axios.get("/search/categories", {
          params: {
            categoryId,
            subcategoryId,
            ...filters,
            page: currentPage,
            limit: 15,
          },
        });

        setFilteredParts(res.data.parts);
        setOriginalSearchResults(res.data.parts);
        setTotalPages(res.data.totalPages);
      } catch (err) {
        console.error(err);
      }
    };

    fetchParts();
  }, [location.search, currentPage, filters]);

  return (
    <>
      <div>
        {/* <Header /> */}
        <section id="banner">
          <div className="Main-div">
            <TopNavBar />
            <div className="TopSearchBar">
              <TopSearchBar />
            </div>
            <div className="container">
              <div className="bnr-div">
                <Middle initialFilters={filters} />
              </div>

              <div
                className="BuildingProductList"
                // style={{ width: "90%", alignContent: "center", margin: "auto" }}
              >
                {/* Advanced Filter on left */}
                <div className="col-lg-3">
                  <div className="advanced-filter-card p-3 mt-5">
                    <Advancedfilter
                      subCategories={subCategories}
                      setParentFilters={setFilters}
                    />
                  </div>
                </div>

                {/* Parts list / Search results */}
                <div className="col-lg-9">
                  {/* SEARCH RESULT + FILTER BUTTONS IN SAME ROW */}
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h6 className="m-0">
                      Search results ({filteredParts.length})
                    </h6>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-outline-dark"
                        onClick={() =>
                          setFilters({ ...filters, partQuality: "" })
                        }
                      >
                        All
                      </button>

                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() =>
                          setFilters({ ...filters, partQuality: "Genuine" })
                        }
                      >
                        Genuine
                      </button>

                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          setFilters({ ...filters, partQuality: "Aftermarket" })
                        }
                      >
                        Aftermarket
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table search-table">
                      <tbody>
                        <tr>
                          <td colSpan="8" className="p-0">
                            <div className="product-header-row">
                              <div className="head-cell name">Name</div>
                              <div className="head-cell">Part No</div>
                              <div className="head-cell">Brand</div>
                              <div className="head-cell">Model</div>
                              <div className="head-cell">Category</div>
                              <div className="head-cell">Region</div>
                              <div className="head-cell">Year</div>
                              <div className="head-cell icon"></div>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="8" className="border-td p-0">
                            <table className="table search-inner-table">
                              <tbody>
                                {filteredParts.length > 0 ? (
                                  filteredParts.map((part, index) => (
                                    <tr
                                      key={index}
                                      className="product-row-card"
                                    >
                                      <td colSpan="8">
                                        <div className="product-row">
                                          <div className="cell name">
                                            <Link
                                              to={`/singleproduct/${part._id}`}
                                              state={{
                                                parts,
                                                spareCategory,
                                                spareBrand,
                                                spareModels,
                                                region,
                                              }}
                                            >
                                              {part.name}
                                            </Link>
                                          </div>
                                          <div className="cell">
                                            {part.partNo}
                                          </div>
                                          <div className="cell">
                                            {toTitleCase(
                                              getBrandName(part?.brandId)
                                            )}
                                          </div>
                                          <div className="cell">
                                            {toTitleCase(
                                              getModelName(part?.modelId)
                                            )}
                                          </div>
                                          <div className="cell">
                                            {toTitleCase(
                                              getCategoryName(part?.categoryId)
                                            )}
                                          </div>
                                          <div className="cell">
                                            {toTitleCase(
                                              getRegionName(part?.regionId)
                                            )}
                                          </div>
                                          <div className="cell">
                                            {part.year}
                                          </div>

                                          <div className="cell icon">
                                            <Link
                                              to={`/singleproduct/${part._id}`}
                                              state={{
                                                parts,
                                                spareCategory,
                                                spareBrand,
                                                spareModels,
                                                region,
                                              }}
                                            >
                                              <img src="images/go.png" />
                                            </Link>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="8"
                                      className="text-center"
                                      justifyContent="center"
                                    >
                                      <NoData />
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="pagination-container d-flex justify-content-end align-items-center mt-4">
                      <button
                        className="pagination-btn"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        <i className="fa fa-arrow-left"></i>
                      </button>

                      <span className="mx-3">
                        {currentPage} of {totalPages}
                      </span>

                      <button
                        className="pagination-btn"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        <i className="fa fa-arrow-right"></i>
                      </button>
                    </div>

                    {/* Advanced Filter results */}
                    {/* {advResults.length > 0 && (
                  <>
                    <h5 className="mt-4 mb-3">Advanced Search Results</h5>
                    <div className="row">
                      {advResults.map((product, index) => (
                        <PartCard key={index} product={product} />
                      ))}
                    </div>
                  </>
                )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
